import React from 'react';

export function LinkIcon({ fill = '#818998' }: { fill?: string }) {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_3530_16196)">
                <path
                    d="M9.75 9.09701L10.9167 7.92603V14.9167H1V6.75C1 5.78167 1.7875 5 2.75 5H8.18729L7.01875 6.16667H2.75C2.42917 6.16667 2.16667 6.42917 2.16667 6.75V13.75H9.75V9.09701Z"
                    fill={fill}
                />
                <path
                    d="M11.9068 2.94732L6.49919 2.9432L6.49919 4.10639L11.086 4.10639L4.87494 10.3174L5.70402 11.1465L11.9109 4.93959L11.9109 9.56761L13.0741 9.56761L13.0741 4.11464C13.0741 3.47117 12.5503 2.94732 11.9068 2.94732Z"
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id="clip0_3530_16196">
                    <rect width="14" height="14" fill="white" transform="translate(1 1)" />
                </clipPath>
            </defs>
        </svg>
    );
}
